import { getLocalStorage } from 'common/utils/localstorage'
import isEmpty from 'lodash/isEmpty'
import { ACCESS_TOKEN_KEY } from 'modules/auth/constants'
import { useEffect, useState } from 'react'

export default function useAuthenticated() {
  const ac = getLocalStorage(ACCESS_TOKEN_KEY)
  const [authenticated, setAuthenticated] = useState(!isEmpty(ac))

  useEffect(() => {
    if (ac) {
      setAuthenticated(true)
    }
  }, [ac])

  return authenticated
}
